module.exports = __webpack_public_path__ + "static/media/ico_user_new.9a2a02cb.svg";